// ChatWrapper.js
import { useState, useContext, useEffect } from 'react';
import Chat from '../../pages/Chat';
import ChatMobile from '../../pages/Mobile/ChatMobile';
import { useMediaQuery } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { AuthContext } from '../../authContext';
import PageWithTopo from '../PageWithTopo';
import { useTranslation } from 'react-i18next';

function ChatWrapper({ totalCost, setTotalCost, sessionId, setSessionId, user, assistant }) {
  const { t: tCommon } = useTranslation('common');
  const isMobile = useMediaQuery('(max-width: 665px)');
  // Recebendo o Id do assistente a partir do Hub
  const location = useLocation();
  const assistantId = location.state?.assistantId || {};
  // Quando o usuário entra direto no chat (sem passar pelo Hub), o nome do
  // assistente não está no estado do AppRoutes. Lemos do location.state para
  // que o Topo mostre o nome e a seta de voltar normalmente.
  const assistantFromState = location.state?.assistantName || null;

  const { newSessionId } = useContext(AuthContext);

  const [chatHistory, setChatHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sessions, setSessions] = useState([]);
  const [messageSent, setMessageSent] = useState(false);
  const [selectedSession, setSelectedSession] = useState(null);
  const [summaryInfo, setSummaryInfo] = useState({
    label: tCommon('new_chat'),
    status: false,
    session_id: sessionId,
    setMessageSent:false
  });

  useEffect(() => {
    const generatedSessionId = newSessionId();
    setSummaryInfo({ label: tCommon('new_chat'), status: false, session_id: generatedSessionId });
    setSelectedSession(generatedSessionId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const effectiveAssistant = assistant || assistantFromState;

  return isMobile ? (
    <ChatMobile
      chatHistory={chatHistory}
      setChatHistory={setChatHistory}
      loading={loading}
      setLoading={setLoading}
      sessions={sessions}
      setSessions={setSessions}
      selectedSession={selectedSession}
      setSelectedSession={setSelectedSession}
      summaryInfo={summaryInfo}
      setSummaryInfo={setSummaryInfo}
      totalCost={totalCost}
      setTotalCost={setTotalCost}
      sessionId={sessionId}
      setSessionId={setSessionId}
      user={user}
      assistant={effectiveAssistant}
      assistantId={assistantId}
      messageSent={messageSent}
      setMessageSent={setMessageSent}
    />
  ) : (
    <PageWithTopo assistant={effectiveAssistant} sessionId={sessionId}>
        <Chat
        chatHistory={chatHistory}
        setChatHistory={setChatHistory}
        loading={loading}
        setLoading={setLoading}
        sessions={sessions}
        setSessions={setSessions}
        selectedSession={selectedSession}
        setSelectedSession={setSelectedSession}
        summaryInfo={summaryInfo}
        setSummaryInfo={setSummaryInfo}
        totalCost={totalCost}
        setTotalCost={setTotalCost}
        sessionId={sessionId}
        setSessionId={setSessionId}
        user={user}
        assistant={effectiveAssistant}
        assistantId={assistantId}
        />
    </PageWithTopo>
  );
}

export default ChatWrapper;
